@if (pronto() && cards().length > 0) {
  <section class="servicos-procurados" aria-labelledby="servicos-procurados-titulo">
    <h2 class="servicos-procurados-titulo" id="servicos-procurados-titulo">
      Serviços mais procurados
    </h2>

    <div class="servicos-procurados-grade">
      @for (servico of cards(); track servico.id) {
        <a class="servicos-procurados-card" [routerLink]="servico.link">
          <div class="servicos-procurados-imagem-wrap">
            <img
              class="servicos-procurados-imagem"
              [ngSrc]="imagemDe(servico)"
              fill
              alt=""
              (error)="imagemFalhou(servico.id)"
            />
            <span
              class="servicos-procurados-selo"
              [attr.data-categoria-servicos-cor]="servico.cor"
              aria-hidden="true"
            >
              {{ servico.inicial }}
            </span>
          </div>

          <div class="servicos-procurados-conteudo">
            <h3 class="servicos-procurados-card-titulo">{{ servico.titulo }}</h3>
            <p class="servicos-procurados-card-descricao">{{ servico.descricao }}</p>
          </div>
        </a>
      }
    </div>
  </section>
}
